import brand from '../../../branding';

const base = {
  baseFontFamily: '"Arial", sans-serif',
  baseFontSize: '16px',
  baseFontWeight: '400',
  baseLineHeight: '1.5',
  titleFontFamily: '"Arial", sans-serif',
  titleFontWeight: '700',
  titleLineHeight: '1.5',
};

export default { ...base, ...(brand.typography || {}) };
